'use strict';

var $              = require('jquery');
var DraggableCore  = require('../core/core__draggable.js');
var InspectorGroup = require('./inspector__group.js');
var InspectorModalBox = require('./inspector__modalbox.js');
var Velocity       = require('velocity-animate');

/**
 * Creates an inspector
 *
 * @class
 */

class Inspector extends DraggableCore {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'name': '',
                'description': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__inspector js-editor__inspector'>
                <div class="editor__inspector__title js-editor__inspector__title js-cio-ui-templates__draggable__handle clearfix">
                    <div class="editor__inspector__title__text js-editor__inspector__title__text">
                        <%- name %>
                    </div>
                </div>
                <div class="editor__inspector__items js-inspector__items"></div>
            </div>
        `;

        super.render();

        // hide at first
        this.$el.css('opacity', 0);
    }


    /**
     * Adds a group to the inspector
     */
    addGroup(){
        return new InspectorGroup({
            target: $('.js-inspector__items', this.$el)
        });
    }

    /**
     * Set inspector title
     */
    setTitle(title){
        $('.js-editor__inspector__title__text', this.$el).html(title);
    }

    /**
     * Set inverted inspector head style
     */
    setInvertedHeader(){
        $('.js-editor__inspector__title', this.$el).addClass("editor__inspector__title--inverted");
    }

    /**
     * get width
     */
    getWidth(){
        return this.$el.width();
    }

    /**
     * Visually show the inspector
     * @param {Function} completeCallBack - optional function that gets called on complete
     */
    show(completeCallBack){
        this.$el.css('pointer-events', 'auto');
        Velocity(this.$el, "stop");
        Velocity(this.$el, {
            'opacity': 1.0
        }, 220, function () {
            if (typeof completeCallBack === 'function') {
                completeCallBack();
            }
        });
    }

    /**
     * Visually hide the inspector
     */
    hide(){
        var self = this;
        this.$el.find(":focus").blur();
        Velocity(this.$el, "stop");
        Velocity(this.$el, {
            'opacity': 0
        }, 220, function () {
            self.$el.css('pointer-events', 'none'); // much less expensive call then show/hide
        });
    }

    /**
     * Clears the inspector groups
     */
    clear(){
        $('.js-inspector__items',this.$el).html('');
    }

}
module.exports = Inspector;
